// Test class for creating assets
import * as THREE from "three"
import Experience from "../Experience"

export default class Sun{
    constructor(){
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        //console.log("Sun Class")
        this.setGeometry()
        this.setTextures()
        this.setMaterials()
        this.setMesh()
    }

    setGeometry(){
        this.geometry = new THREE.SphereGeometry(1, 32, 32)
    }
    setTextures(){
        this.textures = {}
        this.textures.color = this.resources.items.sunTexture
        this.textures.color.colorSpace = THREE.SRGBColorSpace
        //encoding this.environmentMap.texture.colorSpace = THREE.SRGBColorSpace

    }
    setMaterials(){
        this.material = new THREE.MeshPhysicalMaterial({
            color:0xffffff,
            emissive: 0xffffff,
            emissiveIntensity: 1,
            emissiveMap: this.textures.color
        })
    }
    setMesh(){
        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )
        this.scene.add(this.mesh)
        //console.log("log children of the scene")
        //console.log(this.scene.children)
    }
}

